import { GET_AUDIT_LOGS, SET_AUDIT_LOG_ERROR } from '../actions/types';

const initialState = {
    data: [],
    total: 0,
    page: 1,
    limit: 10,
    totalPages: 0,
    error: null
};

export default function auditLogReducer(state = initialState, action) {
    switch (action.type) {
        case GET_AUDIT_LOGS:
            return {
                ...state,
                data: action.payload.data || [],
                total: action.payload.total || 0,
                page: action.payload.page || 1,
                limit: action.payload.limit || 10,
                totalPages: action.payload.totalPages || 0,
                error: null
            };
        case SET_AUDIT_LOG_ERROR:
            return { ...state, error: action.payload };
        default:
            return state;
    }
}
